import { usePut } from '../../../sharedModules/hooks/useQuery';

export function useAssignUser() {
  return usePut();
}

export function assignUserVariables(userId: number, servmanDepartmentId: number | null) {
  return {
    url: `/collections/department_assignments/${userId}`,
    data: { servman_department_id: servmanDepartmentId },
  };
}
